import React from "react";
import cx from "classnames";
import AgencyVerificationForm from "../AgencyVerificationForm/AgencyVerificationForm.jsx";

const AgencyVerificationBanner = (props) => {
  const {
    title,
    text,
    agencyName,
    city,
    submitLabel,
    stateSelect,
    zipCode,
    serviceState,
    label,
    errorMessage
  } = props;

  return (
    <section className={cx("find-office-banner js-dynamic-banner")}>
      <div className="find-office-banner__content">
        <div className="find-office-banner__content-inner find-office-banner__two-col">
          <div className="find-office-banner__main">
            <div className="find-office-banner__title-row">
              {title && <h2 className="find-office-banner__title">{title}</h2>}
            </div>

            {text && (
              <div
                className="find-office-banner__text"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </div>

          <aside className="find-office-banner__aside">
            <AgencyVerificationForm
              label={label}
              agencyName={agencyName}
              city={city}
              stateSelect={stateSelect}
              serviceState={serviceState}
              zipCode={zipCode}
              submitLabel={submitLabel}
              errorMessage={errorMessage}
            />
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AgencyVerificationBanner;
